import React from "react";
import { Link } from "react-router-dom";
import { MdArrowForward } from "react-icons/md";
import { RiCheckboxCircleLine } from "react-icons/ri";

import ContainedButton from "components/layout/form/containedButton";

import {
  ButtonContainer,
  Container,
  HeaderContainer,
  SuccessContainer,
} from "./styles";

const SuccessRegister = (): JSX.Element => {
  return (
    <Container>
      <HeaderContainer>
        <h1>Tudo certo!</h1>
        <h2>
          Agora você pode acessar seu portal e visualizar todas suas unidades em
          um único login
        </h2>
      </HeaderContainer>
      <SuccessContainer>
        <RiCheckboxCircleLine size={60} />
        <p>Seu cadastro foi realizado com sucesso!</p>
      </SuccessContainer>

      <ButtonContainer>
        <Link to="/">
          <ContainedButton
            TrailingIcon={MdArrowForward}
            propsTrailingIcon={{
              size: 20,
            }}
            block
          >
            Acesse o portal
          </ContainedButton>
        </Link>
      </ButtonContainer>
    </Container>
  );
};

export default SuccessRegister;
